module.exports = __webpack_public_path__ + "static/img/10.19ab212.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/10.png
// module id = +zUC
// module chunks = 0